import addToCartController from './shared/utils/product-add-to-cart.js';

class ProductStickyBar extends HTMLElement {
  constructor() {
    super();
    this.updateButtonState = this.updateButtonState.bind(this);
    this.stickyBarPriceContainer = null;
    this.stickyBarButton = null;
    this.productPricesContainers = null;
    this.productAddToCartButton = null;
    this.mainProductSection = null;

    this.isVisible = false;
    this.isAnimating = false;
  }

  connectedCallback() {
    this.abortController = new AbortController();
    this.stickyBarPriceContainer = this.querySelector('.product-sticky-bar__price');
    this.stickyBarButton = this.querySelector('button');
    this.productPricesContainers = document.querySelectorAll('.product__price');
    this.productAddToCartButton = document.querySelector('.product-form button[data-add-to-cart]');
    this.mainProductSection = document.querySelector('.main-product-section');

    if (this.stickyBarButton) {
      this.stickyBarButton.addEventListener('click', this.addToCart.bind(this), {
        signal: this.abortController.signal,
      });
      addToCartController.subscribe(this.updateButtonState, { signal: this.abortController.signal });
    }

    this.copyPrice();

    window.addEventListener('scroll', this.handleScroll.bind(this), { signal: this.abortController.signal });
    this.handleScroll();

    this.addEventListener('transitionend', this.onTransitionEnd.bind(this), { signal: this.abortController.signal });
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  show() {
    if (!this.isVisible && !this.isAnimating) {
      this.isVisible = true;
      this.isAnimating = true;

      this.style.visibility = 'visible';
      this.style.transform = 'translateY(0)';
    }
  }

  hide() {
    if (this.isVisible && !this.isAnimating) {
      this.isVisible = false;
      this.isAnimating = true;

      this.style.transform = 'translateY(-100%)';
    }
  }

  handleScroll() {
    if (!this.mainProductSection) return;

    const sectionRect = this.mainProductSection.getBoundingClientRect();

    if (sectionRect.bottom <= 0) {
      this.show();
    } else {
      this.hide();
    }
  }

  onTransitionEnd(event) {
    if (event.propertyName === 'transform' || event.propertyName === 'opacity') {
      this.isAnimating = false;

      if (!this.isVisible) {
        this.style.visibility = 'hidden';
      }
    }
  }

  addToCart() {
    if (this.productAddToCartButton && !this.stickyBarButton.disabled) {
      this.productAddToCartButton.click();
    }
  }

  copyPrice() {
    this.productPricesContainers.forEach((productPriceContainer) => {
      const price = productPriceContainer.querySelector('.price-item').innerText;
      const priceInfo = productPriceContainer.querySelector('.price-info').innerText;

      this.stickyBarPriceContainer.innerHTML += `<p>${price} <span>${priceInfo}</span></p>`;
    });
  }

  updateButtonState(state) {
    if (this.stickyBarButton) {
      this.stickyBarButton.disabled = state.isDisabled;
    }
  }
}

if (!customElements.get('product-sticky-bar')) {
  customElements.define('product-sticky-bar', ProductStickyBar);
}
